import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import { navigate } from "gatsby";

import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import EmailIcon from "@material-ui/icons/Email";
import InfoIcon from "@material-ui/icons/Info";
import PaymentIcon from "@material-ui/icons/Payment";
import PeopleIcon from "@material-ui/icons/PeopleAlt";
import PostAddIcon from "@material-ui/icons/PostAdd";
import RoomIcon from "@material-ui/icons/Room";
import AddToHomeScreenIcon from "@material-ui/icons/AddToHomeScreen";
import RestoreIcon from "@material-ui/icons/Restore";
import SettingsSystemDaydreamIcon from "@material-ui/icons/SettingsSystemDaydream";
// import SettingsIcon from "@material-ui/icons/Settings"
import WidgetsIcon from "@material-ui/icons/Widgets";
// import BubbleChartIcon from "@material-ui/icons/BubbleChart"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { Amazonaws, Microsoftazure } from "@icons-pack/react-simple-icons";

import GoogleCloudIcon from "../../img/icons/vendor/google-cloud.svg";
import CloudIcon from "@material-ui/icons/Cloud";
import AzureIcon from "../../img/icons/vendor/azure.svg"


import AwsCredentials from "../AwsCredentials";
import GcpCredentials from "../GcpCredentials/GcpCredentials";
import AzureCredentials from "../AzureCredentials/AzureCredentials";

import { CustomerDetails } from "../Auth";

import Badge from "../Badge";

import CollapsibleItemGroup from "./CollapsibleItemGroup";
import MenuButton from "./MenuButton";
import NavLink from "./NavLink";

class NavMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeNavPath: props.path.pathname };
    this.signOut = this.signOut.bind(this);
    this.setActiveGroup = this.setActiveGroup.bind(this);
    this.getNavPath = this.getNavPath.bind(this);
  }

  async signOut() {
    try {
      await Auth.signOut();
      navigate("/");
    } catch (error) {
      console.log("error signing out: ", error);
    }
  }

  setActiveGroup(navComponent) {
    if (this.state.activeNavPath.startsWith(navComponent.props.path)) {
      // Toggle this closed by setting the active nav path to the parent
      let pathComponents = navComponent.props.path.split("/");
      pathComponents.pop();
      this.setState({ activeNavPath: pathComponents.join("/") });
    } else {
      // Need to make parent nav components active too
      this.setState({ activeNavPath: navComponent.props.path });
    }
  }

  getNavPath() {
    if (this.props.open) {
      return this.state.activeNavPath;
    } else {
      return "/";
    }
  }

  render() {
    let navPath = this.getNavPath();
    return (
      <>
        <div className="nav__header">
          <AwsCredentials />
          <GcpCredentials />
          <AzureCredentials />
        </div>

        <div className="nav__main">
          <ul className="nav__menu">
            <NavLink
              to="/"
              text="Home"
              icon={<HomeIcon style={{ color: "#009688" }} />}
            />
            <NavLink
              to="/demowebsites/"
              text="Try me"
              icon={<SettingsSystemDaydreamIcon style={{ color: "#ff6699" }} />}
            />

            {/* <NavLink
              to="/demowebsites/"
              text="Try me Twice"
              icon={<SettingsSystemDaydreamIcon style={{ color: "#ff6699" }} />}
            /> */}

            <CollapsibleItemGroup
              text="Amazon Web Services"
              icon={<Amazonaws color="#ff9900" width={24} height={24} />}
              onClick={this.setActiveGroup}
              activeNavPath={navPath}
              path="/aws"
            >
              <NavLink to="/aws/get-credentials" text="Credentials & Region" />

              <CollapsibleItemGroup
                text="Management"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/management"
              >
                <NavLink
                  to="/aws/management/landingzones"
                  text="Landing Zones"
                />
                <NavLink
                  to="/aws/management/orgunits"
                  text="Units & Accounts"
                />

                {/* <NavLink to="/aws/management/accounts" text="Member Accounts"/> */}
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Identity"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/authentication"
              >
                <NavLink to="/aws/authentication/iam" text="IAM">
                  {/*<Badge>Soon</Badge>*/}
                </NavLink>
                <NavLink to="/aws/authentication/sso" text="SSO">
                  {/*<Badge>Soon</Badge>*/}
                </NavLink>
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Networking"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/networking"
              >
                <NavLink to="/aws/networking/vpc" text="VPCs"></NavLink>
                <NavLink to="/aws/networking/subnets" text="Subnets" />
                <NavLink to="/aws/networking/endpoints" text="VPC Endpoints" />
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Content Delivery "
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/cdn"
              >
                <NavLink to="/aws/cdn/distribution" text="Distributions" />
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Compute"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/compute"
              >
                <NavLink to="/aws/compute/ec2" text="Instances">
                  {/*<Badge>Free</Badge>*/}
                </NavLink>
                <NavLink to="/aws/compute/sg" text="Security Groups" />
                <NavLink to="/aws/compute/autoscaling" text="Autoscaling" />
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Containers"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/containers"
              >
                <NavLink to="/aws/containers/k8s" text="Clusters"></NavLink>
                <NavLink to="#" text="Node Groups"></NavLink>

                {/* <NavLink to="/aws/containers/ecs" text="ECS"/> */}
                {/* <NavLink to="/aws/containers/ecr" text="ECR"/> */}
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Load Balancing"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/loadbalancing"
              >
                <NavLink
                  to="/aws/loadbalancing/alb"
                  text="Load Balancers"
                ></NavLink>
                <NavLink to="#" text="Target Groups"></NavLink>
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Databases"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/databases"
              >
                <NavLink to="/aws/databases/rds" text="RDS"></NavLink>
                <NavLink to="/aws/databases/dynamodb" text="DynamoDB">
                  {/*<Badge>Soon</Badge>*/}
                </NavLink>
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Storage"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/storage"
              >
                <NavLink to="/aws/storage/buckets" text="Buckets">
                  {/*<Badge>Free</Badge>*/}
                </NavLink>
                {/* <NavLink to="/aws/storage/volumes" text="Volumes">
                </NavLink> */}
                {/*<<NavLink to="/aws/storage/san" text="Network Storage">
                  Badge>Free</Badge>
                </NavLink>
                */}
              </CollapsibleItemGroup>

              {/* <CollapsibleItemGroup
                text="Analytics"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/analytics"
              >
                <NavLink to="/aws/analytics/emr" text="EMR" />
              </CollapsibleItemGroup> */}

              {/* <CollapsibleItemGroup
                text="Messaging"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/aws/messaging"
              >
                <NavLink to="/aws/messaging/sqs" text="SQS Queue">
                </NavLink>
                <NavLink to="/aws/messaging/kinesis" text="Kinesis">
                </NavLink>
              </CollapsibleItemGroup> */}

              <NavLink
                to="/aws/infrastructure-stacks"
                text="Infrastructure Stacks"
              />
              {/* <NavLink to="https://archie-aws-inventory.s3.eu-west-1.amazonaws.com/prerequisites_elb.html" target="_blank" text="Inventory"/> */}
            </CollapsibleItemGroup>

            <CollapsibleItemGroup
              text="Google Cloud Platform"
              icon={<img src={GoogleCloudIcon} width={24} height={19} />}
              onClick={this.setActiveGroup}
              activeNavPath={navPath}
              path="/gcp"
            >
              <NavLink to="/gcp/get-credentials" text="Credentials & Region" />

              <CollapsibleItemGroup
                text="Management"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/gcp/management"
              >
                <NavLink
                  to="/gcp/management/landingzones"
                  text="Landing Zones"
                />
                <NavLink
                  to="/gcp/management/projects"
                  text="Folders & Projects"
                />
                {/* <NavLink to="/gcp/management/accounts" text="Projects"/> */}
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Networking"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/gcp/networking"
              >
                <NavLink to="/gcp/networking/vpc" text="VPCs">
                  {/*<Badge>Free</Badge>*/}
                </NavLink>
                <NavLink to="/gcp/networking/subnets" text="Subnets" />
                {/* <NavLink to="/gcp/networking/cdn" text="Content Delivery"/> */}
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Compute"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/gcp/compute"
              >
                <NavLink to="/gcp/compute/instance" text="Instances" />
                <NavLink to="/gcp/compute/lb" text="Load Balancers" />

                {/*<Badge>Free</Badge>*/}
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Containers"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/gcp/containers"
              >
                <NavLink to="/gcp/containers/k8s" text="GKE">
                  {/*<Badge>Free</Badge>*/}
                </NavLink>
                {/* <NavLink to="/aws/containers/ecs" text="ECS"/> */}
                {/* <NavLink to="/aws/containers/ecr" text="ECR"/> */}
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Databases"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/gcp/databases"
              >
                <NavLink
                  // to="/gcp/databases/cloudsql/deploy-predefined-cloudsql"
                  text="CloudSQL"
                ></NavLink>
                {/* <NavLink to="/gcp/databases/datastore" text="Datastore">
                </NavLink> */}
              </CollapsibleItemGroup>

              <CollapsibleItemGroup
                text="Storage"
                onClick={this.setActiveGroup}
                activeNavPath={navPath}
                path="/gcp/storage"
              >
                <NavLink to="#" text="Buckets"></NavLink>
                {/*<NavLink to="/gcp/storage/volumes" text="Volumes">
                  <Badge>Free</Badge>
                </NavLink>
                <NavLink to="/gcp/storage/san" text="Network Storage">
                  Badge>Free</Badge>
                </NavLink>*/}
              </CollapsibleItemGroup>
              <NavLink
                to="/gcp/infrastructure-stacks"
                text="Infrastructure Stacks"
              />
            </CollapsibleItemGroup>

            <CollapsibleItemGroup
              to="/azure"
              text="Microsoft Azure"
              icon={<Microsoftazure color="#035bd9" />}
              onClick={this.setActiveGroup}
              activeNavPath={navPath}
              path="/azure"
            >
              <NavLink to="/azure/get-credentials" text="Credentials & Region" />
            </CollapsibleItemGroup>
            
            <NavLink
              to="/multicloud"
              text="MultiCloud"
              icon={<CloudIcon color="#009688" />}
            />
            <NavLink
              to="/inventory"
              text="History & Deletion"
              icon={<RestoreIcon color="#ff6699" />}
            />

            <CollapsibleItemGroup
              text="Partners"
              icon={<PostAddIcon style={{ color: "#9136A4" }} />}
              onClick={this.setActiveGroup}
              activeNavPath={navPath}
              path="/community"
            >
              <NavLink to="/templates" text="Templates" />
              <NavLink to="/request" text="Request & Share" />
            </CollapsibleItemGroup>

            <NavLink
              to="/tutorial"
              text="Tutorial & FAQ"
              icon={<MenuBookIcon style={{ color: "#00cc66" }} />}
            />

            <CollapsibleItemGroup
              text="About"
              icon={<InfoIcon style={{ color: "ff9800" }} />}
              onClick={this.setActiveGroup}
              activeNavPath={navPath}
              path="/about"
            >
              <NavLink to="/roadmap" text="Roadmap" />
              {/* <NavLink to="/about" text="Archie" />
              <NavLink to="/contact" text="Cloudbuddies" /> */}
              <NavLink to="/feedback" text="Feedback" />
            </CollapsibleItemGroup>

            {/*<NavLink to="/" text="Settings" icon={<SettingsIcon style={{"color": "#3f51b5"}}/>}/>
            <NavLink to="/" text="Become a Member" icon={<BubbleChartIcon style={{"color": "#FFA92D"}}/>}/>*/}
          </ul>

          <ul className="nav__menu">
            <NavLink
              to="/account"
              text="Pricing"
              icon={<PaymentIcon style={{ color: "#88aaff" }} />}
            />
            {this.props.user ? (
              <ListItem>
                <MenuButton className="nav__button" onClick={this.signOut}>
                  <div className="nav__button-inner">
                    <ListItemIcon>
                      <FontAwesomeIcon
                        className="sidebar__link-icon"
                        icon={faSignOutAlt}
                      />
                    </ListItemIcon>
                    <ListItemText disableTypography primary="Sign Out" />
                  </div>
                </MenuButton>
              </ListItem>
            ) : (
              ""
            )}
          </ul>
        </div>

        <div className="nav__footer">
          <CustomerDetails />
        </div>
      </>
    );
  }
}

NavMenu.propTypes = {
  user: PropTypes.object,
  open: PropTypes.bool,
  path: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

NavMenu.defaultProps = {
  path: {
    pathName: "/",
  },
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export { NavMenu };

export default connect(mapStateToProps)(NavMenu);
